import DownloadIcon from '@mui/icons-material/Download';
import { Button } from 'src/components/new/Button';
import { Typography } from 'src/components/new/Typography';

interface DownloadSectionProps {
  onAddressesDownload: () => void;
  onDownloadCertificate: () => void;
  onRequestCertificate?: () => void;
  isCertificateRequested?: boolean;
  isCertificateRequestable: boolean;
  isCertificateDownloadable: boolean;
  jobCreatedAt?: string;
}

const DownloadSection = ({
  onAddressesDownload,
  onDownloadCertificate,
  onRequestCertificate,
  isCertificateRequested,
  isCertificateRequestable,
  isCertificateDownloadable,
  jobCreatedAt,
}: DownloadSectionProps) => {
  const renderCertificateButton = isCertificateRequested ? (
    <Button
      sx={{
        textTransform: 'none',
        width: '50%',
      }}
      startIcon={<DownloadIcon />}
      disabled={true}
      type='secondary'
    >
      Certificate of Service Requested
    </Button>
  ) : isCertificateRequestable ? (
    <Button
      sx={{
        textTransform: 'none',
        width: '50%',
      }}
      type='secondary'
      onClick={onRequestCertificate}
      startIcon={<DownloadIcon />}
    >
      Request Certificate of Service
    </Button>
  ) : (
    <Button
      sx={{
        textTransform: 'none',
        width: '50%',
      }}
      type='primary'
      onClick={onDownloadCertificate}
      disabled={!isCertificateDownloadable}
      startIcon={<DownloadIcon />}
    >
      Download Certificate of Service
    </Button>
  );
  return (
    <>
      <Typography
        sx={{
          marginTop: '0.9375rem',
          marginBottom: '0.9375rem',
          fontWeight: '600',
        }}
      >
        Downloads
      </Typography>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '1rem',
        }}
      >
        <Button
          sx={{
            textTransform: 'none',
            width: '50%',
          }}
          type='secondary'
          startIcon={<DownloadIcon />}
          onClick={onAddressesDownload}
        >
          Download Address List
        </Button>
        {renderCertificateButton}
      </div>
    </>
  );
};

export default DownloadSection;
